const Footer = () => {
  return <>
    <nav className="w-full text-center mb-4 px-2 md:px-6 py-2 max-w-6xl mx-auto flex justify-center border-t mt-8">
    <div className="font-medium text-xs">© 2021 All rights reserved.</div>
    </nav>
  </>
}

export default Footer;